import styled from 'styled-components';

export const HistorySection = styled.div`
  border-left: 2px solid #e8e9ed;
  flex-direction: column;
  align-items: center;
  display: flex;
  min-height: 350px;
  padding: 41px;
  box-sizing: border-box;
  width: 100%;
  min-width: 850px;

  @media (max-width: 720px) {
    border-left: 0;
  }
`;

export const HistoryTable = styled.div`
  width: 100%;
  min-width: 500px;
`
